import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { DiscountsRouteNames, DiscountsRoutePathNames } from '../enums';
import { beforeEnter } from './guards/index';
import { updateRoute } from './update/update';

const List = () => import('../components/list/List.vue');
const Create = () => import('../components/create/Create.vue');

const listRoute = {
  path: buildChildURL(DiscountsRoutePathNames.LIST),
  name: DiscountsRouteNames.DISCOUNTS_LIST,
  component: List,
  beforeEnter: beforeEnter,
} as RouteRecordRaw;

const createRoute = {
  path: buildChildURL(DiscountsRoutePathNames.CREATE),
  name: DiscountsRouteNames.DISCOUNTS_CREATE,
  component: Create,
  beforeEnter: beforeEnter,
} as RouteRecordRaw;

const RystIncentivesManager = () =>
  import('../components/ryst-incentives-manager/RystIncentivesManager.vue');

const rystIncentivesManagerRoute = {
  path: buildChildURL(DiscountsRoutePathNames.RYST_INCENTIVES_MANAGER),
  name: DiscountsRouteNames.RYST_INCENTIVES_MANAGER,
  component: RystIncentivesManager,
  beforeEnter: beforeEnter,
} as RouteRecordRaw;

// Register before `:id` (update) so this path is not matched as a discount id.
const childRoutes: RouteRecordRaw[] = [
  listRoute,
  createRoute,
  rystIncentivesManagerRoute,
  updateRoute,
];

export default childRoutes;
